var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5 mb-0"},[_c('div',{class:_vm.iconClass,staticStyle:{"float":"left"}},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }